export default __webpack_public_path__ + "static/media/timberline-stone-adobe-mocha.2fb8b670.jpg";